export const mutations = {
    setFormaPagamento(state, data){
        state.formaPagamento = data
    },
    setFormasPagamento(state, data){
        state.formasPagamento = data
    },
    setModalExcluirFormaPagamento(state, status){
        state.modalExcluirFormaPagamento = status
    }
}

export default {}